// @ts-nocheck

import { $uniDebug } from "../uni-debug.module"
import { IUniConfig } from "../../uni-base-module"

class JsonDevDirective implements ng.IDirective {
  restrict: "A"
  scope: {
    jsonDev: "<"
    forzar: "<"
  }
  priority: number = -999

  constructor(
    private $log: ng.ILogService,
    private $timeout: ng.ITimeoutService,
    private UniConfig: IUniConfig
  ) {
    this.restrict = "A"
    this.scope = {
      jsonDev: "<",
      forzar: "<"
    }
  }

  compile(element: JQLite, attrs: ng.IAttributes) {
    this.$log.debug("******** Compile jsonDev", element.html())

    if (!attrs.forzar && !this.UniConfig.debug) {
      attrs.jsonDev = ""
      element.removeAttr("json-dev")
      element.empty()
    }

    return this.link
  }

  link(scope, element: JQLite, attrs, ctrls) {
    // $log.debug("Instanciando JsonDevDirective", scope);

    if (attrs.forzar || this.UniConfig.debug) {
      // this.$log.debug("Activando titleDev", element);
      this.$timeout(() => {
        element.addClass("if__dev")
        element.attr("title", attrs.jsonDev)
        element.removeAttr("json-dev")
      }, 2000)
    }
  }

  template() {
    return /* html */ `
<sidebar-tooltip-click>
<div class="json-formatter-container ng-hide pull-right">
<json-formatter json="jsonDev" open="1"></json-formatter>
</div>
<span title-dev="{{::jsonDev | json}}">???</span>
</sidebar-tooltip-click>
`
  }
}

$uniDebug.directive("jsonDev", [
  "$log",
  "$timeout",
  "UniConfig",
  ($log, $timeout, UniConfig) => new JsonDevDirective($log, $timeout, UniConfig)
])

import "./json-dev.directive.scss"
